import { AppState } from '../root.reducer';

export const isPopupShownSelector = (state: AppState) => state.popup.isShown;
export const popupModelSelector = (state: AppState) => state.popup.model;